import { BaseController } from './BaseController';

export default class ExpandableWindowController extends BaseController {
  id = 'ExpandableWindowController';

  init() {
    this.root = this.getRoot();

    this.title = this.getData(this.root, 'title');
    this.titleHide = this.getData(this.root, 'titleHide');

    this.hiddenClass = 'is-folded';
    this.classOverride = 'expand-window-elem';

    this.root.addEventListener('click', this.handleClick);

    this.titleParagraph = document.createElement('h3');
    this.titleParagraph.classList.add(this.classOverride);
    this.titleParagraph.innerHTML = this.title;

    this.imgOpenUrl = this.getData(this.root, 'imageOpen');
    this.imgClosedUrl = this.getData(this.root, 'imageClosed');
    
    this.arrowImage = new Image();
    this.arrowImage.classList.add(this.classOverride);
    
    if (this.root.classList.contains(this.hiddenClass)) {
      this.arrowImage.src = this.imgClosedUrl;
    } else {
      this.arrowImage.src = this.imgOpenUrl;
    }

    this.root.prepend(this.arrowImage);
    this.root.prepend(this.titleParagraph);
  }

  handleClick = (e) => {
    if (e.target.target != "_blank") {
      this.root.classList.toggle(this.hiddenClass);
    }

    if (this.root.classList.contains(this.hiddenClass)) {
      this.titleParagraph.innerText = this.title;
      this.arrowImage.src = this.imgClosedUrl;
    } else {
      this.titleParagraph.innerText = this.titleHide;
      this.arrowImage.src = this.imgOpenUrl;
    }
  }
};
